export * from './multiple/multiple.component';
